module.exports = require("/tmp/build_27486df5/src/lib/gatsby/gatsby-browser.tsx");